module.exports = __webpack_public_path__ + "img/backfocusing_300.8d8b6641.png";